// // Topbar.js
// import React from 'react';
// import { Button } from 'react-bootstrap';
// import '../../assets/css/Sidebar.css';
// const Topbar = ({ toggleSidebar }) => {
//   return (
//     <div className="d-flex justify-content-between align-items-center shadow-sm p-3">
//        <button className="hamburger-btn" onClick={toggleSidebar}>
//         <div className="hamburger-menu">
//           <span className="bar"></span>
//           <span className="bar"></span>
//           <span className="bar"></span>
//         </div>
//       </button>
//       {/* <Button  className="material-icons-outlined icon-color" variant="outline-primary" onClick={toggleSidebar}>
//         Menu
//       </Button> */}
//       <h1 className="h4 mb-0">Admin Dashboard</h1>
//     </div>
//   );
// };

// export default Topbar;

// src/AdminPage/Layout/Topbar.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getUser, logout } from '../../config/auth';
import '../../assets/css/Sidebar.css'; // or your topbar-specific CSS
import Logo from "../../assets/img/hph-logo.png"


const Topbar = () => {
  const user = getUser();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <>
    <div className="topbar-container d-flex justify-content-between align-items-center p-1 bg-light shadow-sm"> 
      <img src={Logo} alt="logo" className='h-15 w-20 ms-2' />
      <h4 className="m-0">Hospital Management</h4>
      <div className="d-flex align-items-center gap-3">
        <span>👤 {user?.fullName || 'User'}</span>
        <button onClick={handleLogout} className="btn btn-outline-danger btn-sm">
          Logout
        </button>
      </div>
    </div>
    </>
  );
};

export default Topbar;
